import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';

import { MaterialModule } from '@shared/angular-material';

import { BeeConfirmNavigationComponent } from './bee-confirm-navigation.component';

@NgModule({
  declarations: [
    BeeConfirmNavigationComponent
  ],
    imports: [
        CommonModule,
        MaterialModule,
        FlexLayoutModule
    ],
  exports: [
    BeeConfirmNavigationComponent
  ]
})
export class BeeConfirmNavigationModule { }
